import { List } from 'immutable';

import BaseStore from './BaseStore';
import config from '../config';
import { ActionTypes } from '../constants/AppConstants';
import DataLayerStore from './DataLayerStore';

function gtag() {
    const dataLayerName = config.get('gtmDataLayer');
    const enableTracking = DataLayerStore.isTrackingEnabled();

    if (window.hasOwnProperty(dataLayerName) && enableTracking) {
        window[dataLayerName].push(arguments);
    }
}

export class FeatureVariantStore extends BaseStore {
    constructor(...args) {
        super(...args);
        gtag('event', 'optimize.callback', {
            callback: this._googleOptimizeCallback
        });
    }

    has(featureName) {
        return this.state.has(featureName) || config.has(featureName);
    }

    get(featureName) {
        return this.state.get(featureName, config.get(featureName));
    }

    async triggerEvent(triggerName) {
        if (window.dataLayer && DataLayerStore.isTrackingEnabled()) {
            await window.dataLayer.push({ event: triggerName });
        }
    }

    waitForGO = (callBack, fallBack) => {
        let GOLoadingAttempts = 0;
        const intervalId = setInterval(() => {
            GOLoadingAttempts++;
            if (window.google_optimize !== undefined) {
                callBack();
                GOLoadingAttempts = 0;
                clearInterval(intervalId);
            }
            if (GOLoadingAttempts > 4) {
                if (typeof fallBack === 'function') {
                    fallBack();
                }
                GOLoadingAttempts = 0;
                clearInterval(intervalId);
            }
        }, 100);
    };

    getAll() {
        let featureVariants = {};
        this.state.forEach((variantId, featureName) => {
            const variantName = this._getVariantName(featureName, variantId);
            featureVariants[featureName] = { variantId, variantName };
        });
        return featureVariants;
    }

    isCurrentVariant(featureName, variant) {
        return this._getVariantId(featureName, variant) === this.get(featureName);
    }

    _getFeatureName(experimentId) {
        return (
            config
                .get('featureExperimentIds')
                .findKey(expId => expId === experimentId) || experimentId
        );
    }

    _getVariantId(featureName, variantName) {
        if (typeof variantName === 'number') {
            return variantName;
        }
        const variants = config
            .get('featureVariants')
            .getIn([featureName], new List());
        return variants.indexOf(variantName);
    }

    _getVariantName(featureName, variantId) {
        const variants = config
            .get('featureVariants')
            .getIn([featureName], new List());
        const variantName = variants.get(variantId);
        return variantName;
    }

    _googleOptimizeCallback = (variantId, experimentId) => {
        try {
            this.setState(
                this.state.set(
                    this._getFeatureName(experimentId),
                    Number(variantId)
                )
            );
        } catch (e) {
            console.error(
                `Error updating variant: ${experimentId} - "${variantId}"`
            );
        }
    };

    // set by booking-engine
    _setFeatureVariant({ feature, variant }) {
        const variantId = this._getVariantId(variant);
        if (variantId >= 0) {
            this.setState(this.state.set(feature, variantId));
        } else {
            console.warn(
                `Unknown ${feature} variant: ${variant}, setting anyway`
            );
            this.setState(this.state.set(feature, variant));
        }
    }

    getActionHandlers() {
        return {
            [ActionTypes.FEATURE_VARIANT_UPDATED]: this._setFeatureVariant
        };
    }
}

export default new FeatureVariantStore();
